import { Injectable } from '@angular/core';
import { environment } from '@env';

@Injectable({ providedIn: 'root' })
export class NewsletterService {

  public showOn(selector: string) {
    const config = {
      account: environment.headwayAccountId,
      translations: { title: 'Últimas novidades', readMore: 'Ler por inteiro', footer: 'Veja mais' },
      selector
    }
    // @ts-ignore
    Headway.init(config)
  }

}
